import { render, staticRenderFns } from "./SsoLogin.vue?vue&type=template&id=58fa83db&scoped=true"
import script from "./SsoLogin.vue?vue&type=script&lang=js"
export * from "./SsoLogin.vue?vue&type=script&lang=js"
import style0 from "./SsoLogin.vue?vue&type=style&index=0&id=58fa83db&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fa83db",
  null
  
)

export default component.exports